import {
	FormItem,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { UsersAndUserGroupsDataModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import {
	UserAndUserGroupCollection,
	UserAndUserGroupKind
} from "client/Features/Users/UserAndUserGroupCollection/UserAndUserGroupCollection";
import { ActiveTab } from "client/Features/Users/UserAndUserGroupTabSelector/UserAndUserGroupTabSelector";
import { PermissionSetModel } from "client/Api/common";
import { attachToUserAndUserGroupCollection } from "client/Features/Users/UserAndUserGroupCollection/attachable";
import styles from "./Owners.module.less";

export type OwnersProps = {
	attachable: IValueInputAttachable<PermissionSetModel>;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export const Owners = (props: OwnersProps): ReactElement => {
	const {
		attachable,
		usersAndUserGroupsData
	} = props;

	return (
		<div className={styles.root}>
			<FormItem height="stretch">
				<UserAndUserGroupCollection
					{...attachToUserAndUserGroupCollection(
						attachable,
						{
							kind: UserAndUserGroupKind.Edit,
							dialogTitleWhenAddingUsersAndUserGroups: localize("_AddGroupsOrUsers")
						}
					)}
					activeTab={ActiveTab.UserGroup}
					allUsersAndUserGroupsData={usersAndUserGroupsData}
				/>

				<ValidationError {...attachable.attachToValidationError()}/>
			</FormItem>
		</div>
	);
};
Owners.displayName = "Owners";
